<template>
	<div slot="body">
		<div class="modal-content">
			<form class action>
				<div class="margin_horizontal">
					<md-field :class="[{ 'md-error': errors.has('firstName') }]">
						<label>{{ $t("beneficialOwners.modal.firstNames") }}</label>
						<md-input
							v-model="form.firstName"
							data-vv-name="firstName"
							required
							v-validate="modelValidations.firstName"
						></md-input>
						<span v-if="errors.has('firstName')" class="validation-error">{{ errors.first('firstName') }}</span>
					</md-field>
					<md-field :class="[{ 'md-error': errors.has('lastName') }]">
						<label>{{ $t("common.lastName") }}</label>
						<md-input
							v-model="form.lastName"
							data-vv-name="lastName"
							required
							v-validate="modelValidations.lastName"
						></md-input>
						<span v-if="errors.has('lastName')" class="validation-error">{{ errors.first('lastName') }}</span>
					</md-field>
					<BirthdayInput
						v-model="form.birthday"
						data-vv-name="birthday"
						v-validate="modelValidations.birthday"
						:error="errors.first('birthday')"
						required
					></BirthdayInput>
					<md-field :class="[{ 'md-error': errors.has('birthplace') }]">
						<label>{{ $t("common.placeOfBirth") }}</label>
						<md-input v-model="form.birthplace"
								  data-vv-name="birthplace"
								  v-validate="modelValidations.birthplace"
								  required
						></md-input>
						<span v-if="errors.has('birthplace')" class="validation-error">{{ errors.first('birthplace') }}</span>
					</md-field>
					<CountrySelect
						v-model="form.nationality"
						:labelText="$t('common.nationality')"
						data-vv-name="nationality"
						v-validate="modelValidations.nationality"
						:error="errors.first('nationality')"
						:companyType=null
						required
					></CountrySelect>
					<div class="margin_top text_left">{{$t("common.mainResidentialAddress")}}*</div>
					<div class="flex">
						<md-field :class="[{ 'md-error': errors.has('residentialAddressStreet') }]" class="flex_2 margin_r">
							<label>{{ $t("common.street") }}</label>
							<md-input v-model="form.residentialAddress.street"
									  data-vv-name="residentialAddressStreet"
									  v-validate="modelValidations.residentialAddressStreet"
									  required
							></md-input>
							<span v-if="errors.has('residentialAddressStreet')" class="validation-error">{{ errors.first('residentialAddressStreet') }}</span>
						</md-field>
						<md-field :class="[{ 'md-error': errors.has('residentialAddressHouseNumber') }]" class="flex_1">
							<label>{{ $t("common.houseNumber") }}</label>
							<md-input v-model="form.residentialAddress.houseNumber"
									  data-vv-name="residentialAddressHouseNumber"
									  v-validate="modelValidations.residentialAddressHouseNumber"
									  required
							></md-input>
							<span v-if="errors.has('residentialAddressHouseNumber')" class="validation-error">{{ errors.first('residentialAddressHouseNumber') }}</span>
						</md-field>
					</div>
					<div class="flex">
						<md-field :class="[{ 'md-error': errors.has('residentialAddressPostCode') }]" class="flex_1 margin_r">
							<label>{{ $t("common.postcode") }}</label>
							<md-input v-model="form.residentialAddress.postCode"
									  data-vv-name="residentialAddressPostCode"
									  v-validate="modelValidations.residentialAddressPostCode"
									  required
							></md-input>
							<span v-if="errors.has('residentialAddressPostCode')" class="validation-error">{{ errors.first('residentialAddressPostCode') }}</span>
						</md-field>
						<md-field :class="[{ 'md-error': errors.has('residentialAddressCity') }]" class="flex_2">
							<label>{{ $t("common.city") }}</label>
							<md-input v-model="form.residentialAddress.city"
									  data-vv-name="residentialAddressCity"
									  v-validate="modelValidations.residentialAddressCity"
									  required
							></md-input>
							<span v-if="errors.has('residentialAddressCity')" class="validation-error">{{ errors.first('residentialAddressCity') }}</span>
						</md-field>
					</div>
					<CountrySelect
						v-model="form.residentialAddress.country"
						:labelText="$t('common.country')"
						data-vv-name="residentialAddressCountry"
						v-validate="modelValidations.residentialAddressCountry"
						:error="errors.first('residentialAddressCountry')"
						:companyType=null
						required
					></CountrySelect>
				</div>
			</form>
		</div>

		<div class="flex flex_between base_margin">
			<md-button class="md-blank" @click="closeNoticeModal">{{ $t("common.close") }}</md-button>
			<md-button
				class="opacity_5"
				:class="{ 'md-primary': isFormValid }"
				@click.stop="submitOwner"
			>{{ $t("common.save") }}
			</md-button>
		</div>
	</div>
</template>
<script>
import CountrySelect from "@/components/templates/select/CountrySelect.vue";
import DatePicker from "@/components/templates/DatePicker";
import {mapGetters} from "vuex";
import BirthdayInput from "@/components/templates/common/BirthdayInput";
import {validateForm, validateRequiredFields} from "@/validation/validation";
import {enumDef} from "src/common/enumDefs";

export default {
	components: { BirthdayInput, DatePicker, CountrySelect },
	data() {
		return {
			enumDef: enumDef,
			modelValidations: {
				firstName: {
					required: true
				},
				lastName: {
					required: true
				},
				birthday: {
					required: true
				},
				birthplace: {
					required: true
				},
				nationality: {
					required: true
				},
				residentialAddressStreet: {
					required: true
				},
				residentialAddressHouseNumber: {
					required: true
				},
				residentialAddressPostCode: {
					required: true
				},
				residentialAddressCity: {
					required: true
				},
				residentialAddressCountry: {
					required: true
				},
			},
			form: {
				id: "",
				firstName: "",
				lastName: "",
				birthday: "",
				birthplace: "",
				nationality: "",
				residentialAddress: {
					street: "",
					houseNumber: "",
					postCode: "",
					city: "",
					country: ""
				}
			}
		};
	},
	beforeMount() {
		let { editType } = this.noticeModalData;
		if (editType !== "add") {
			this.form = { ...this.form, ...this.noticeModalData.data };
		}
	},
	methods: {
		closeNoticeModal() {
			this.$store.dispatch("setActionNoticModal", { show: false, data: {} });
		},
		submitOwner() {
			validateForm(this, this.$validator)
				.then(() => {
					this.noticeModalData.suFun(this.form);
					this.closeNoticeModal();
				})
				.catch(this.toast);
		}
	},
	computed: {
		...mapGetters({
			noticeModalData: "noticeModalData",
			noticeModalShow: "noticeModalShow"
		}),
		isFormValid() {
			return validateRequiredFields(this.form, this.modelValidations);
		}
	}
};
</script>